// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Home from './Pages/Home';
// import About from './Pages/About';
// import Skills from './Pages/Skills';
// import Projects from './Pages/Projects';
// import Contact from './Pages/Contact';
// import './App.css';


// const App = () => {
//   return (
//     <Router>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/skills" element={<Skills />} />
//         <Route path="/projects" element={<Projects />} />
//         <Route path="/contact" element={<Contact />} />
//       </Routes>
//     </Router>
//   );
// };

// export default App;

// // App.js
// // import React from 'react';
// // import Navbar from './components/Navbar';
// // import Home from './Pages/Home';
// // import About from './Pages/About';
// // import Skills from './Pages/Skills';
// // import Projects from './Pages/Projects';
// // import Contact from './Pages/Contact';
// // import './App.css';

// // const App = () => {
// //   return (
// //     <>
// //       <Navbar />
// //       <main>
// //         <section id="home"><Home /></section>
// //         <section id="about"><About /></section>
// //         <section id="skills"><Skills /></section>
// //         <section id="projects"><Projects /></section>
// //         <section id="contact"><Contact /></section>
// //       </main>
// //     </>
// //   );
// // };

// // export default App;


// App.js
import React from 'react';
import Navbar from './components/Navbar';
import Home from './Pages/Home';
import './App.css';

const App = () => {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
};

export default App;

